export default "__VITE_ASSET__BCZr3fNr__"